/**
 * @file Generated by js-routes 2.3.6. Based on Rails 8.1.3.1 routes of Savanna::Application.
 * @version 282d75515a7925158ea35b6a768a3061ca0409364d330a26ad0752a349445f8f
 * @see https://github.com/railsware/js-routes
 */
// eslint-disable-next-line
const __jsr = (
// eslint-disable-next-line
() => {
    const hasProp = (value, key) => Object.prototype.hasOwnProperty.call(value, key);
    let NodeTypes;
    (function (NodeTypes) {
        NodeTypes[NodeTypes["GROUP"] = 1] = "GROUP";
        NodeTypes[NodeTypes["CAT"] = 2] = "CAT";
        NodeTypes[NodeTypes["SYMBOL"] = 3] = "SYMBOL";
        NodeTypes[NodeTypes["OR"] = 4] = "OR";
        NodeTypes[NodeTypes["STAR"] = 5] = "STAR";
        NodeTypes[NodeTypes["LITERAL"] = 6] = "LITERAL";
        NodeTypes[NodeTypes["SLASH"] = 7] = "SLASH";
        NodeTypes[NodeTypes["DOT"] = 8] = "DOT";
    })(NodeTypes || (NodeTypes = {}));
    const isBrowser = typeof window !== "undefined";
    const UnescapedSpecials = "-._~!$&'()*+,;=:@"
        .split("")
        .map((s) => s.charCodeAt(0));
    const UnescapedRanges = [
        ["a", "z"],
        ["A", "Z"],
        ["0", "9"],
    ].map((range) => range.map((s) => s.charCodeAt(0)));
    const ModuleReferences = {
        CJS: {
            define(routes) {
                if (module) {
                    module.exports = routes;
                }
            },
            isSupported() {
                return typeof module === "object";
            },
        },
        AMD: {
            define(routes) {
                if (define) {
                    define([], function () {
                        return routes;
                    });
                }
            },
            isSupported() {
                return typeof define === "function" && !!define.amd;
            },
        },
        UMD: {
            define(routes) {
                if (ModuleReferences.AMD.isSupported()) {
                    ModuleReferences.AMD.define(routes);
                }
                else {
                    if (ModuleReferences.CJS.isSupported()) {
                        try {
                            ModuleReferences.CJS.define(routes);
                        }
                        catch (error) {
                            if (error.name !== "TypeError")
                                throw error;
                        }
                    }
                }
            },
            isSupported() {
                return (ModuleReferences.AMD.isSupported() ||
                    ModuleReferences.CJS.isSupported());
            },
        },
        ESM: {
            define() {
                // Module can only be defined using ruby code generation
            },
            isSupported() {
                // Its impossible to check if "export" keyword is supported
                return true;
            },
        },
        NIL: {
            define() {
                // Defined using const __jsr = 
            },
            isSupported() {
                return true;
            },
        },
        DTS: {
            // Acts the same as ESM
            define(routes) {
                ModuleReferences.ESM.define(routes);
            },
            isSupported() {
                return ModuleReferences.ESM.isSupported();
            },
        },
    };
    class ParametersMissing extends Error {
        constructor(...keys) {
            super(`Route missing required keys: ${keys.join(", ")}`);
            this.keys = keys;
            Object.setPrototypeOf(this, Object.getPrototypeOf(this));
            this.name = ParametersMissing.name;
        }
    }
    const ReservedOptions = [
        "anchor",
        "trailing_slash",
        "subdomain",
        "host",
        "port",
        "protocol",
        "script_name",
    ];
    class UtilsClass {
        constructor() {
            this.configuration = {
                prefix: "",
                default_url_options: {},
                special_options_key: "_options",
                serializer: null || this.default_serializer.bind(this),
            };
        }
        default_serializer(value, prefix) {
            if (!prefix && !this.is_object(value)) {
                throw new Error("Url parameters should be a javascript hash");
            }
            prefix = prefix || "";
            const result = [];
            if (this.is_array(value)) {
                for (const element of value) {
                    result.push(this.default_serializer(element, prefix + "[]"));
                }
            }
            else if (this.is_object(value)) {
                for (let key in value) {
                    if (!hasProp(value, key))
                        continue;
                    let prop = value[key];
                    if (prefix) {
                        key = prefix + "[" + key + "]";
                    }
                    const subvalue = this.default_serializer(prop, key);
                    if (subvalue.length) {
                        result.push(subvalue);
                    }
                }
            }
            else {
                result.push(this.is_not_nullable(value) ||
                    false
                    ? encodeURIComponent(prefix) +
                        "=" +
                        encodeURIComponent("" + (value !== null && value !== void 0 ? value : ""))
                    : encodeURIComponent(prefix));
            }
            return result.join("&");
        }
        serialize(object) {
            return this.configuration.serializer(object);
        }
        extract_options(number_of_params, args) {
            const last_el = args[args.length - 1];
            if ((args.length > number_of_params && last_el === 0) ||
                (this.is_object(last_el) &&
                    !this.looks_like_serialized_model(last_el))) {
                if (this.is_object(last_el)) {
                    delete last_el[this.configuration.special_options_key];
                }
                return {
                    args: args.slice(0, args.length - 1),
                    options: last_el,
                };
            }
            else {
                return { args, options: {} };
            }
        }
        looks_like_serialized_model(object) {
            return (this.is_object(object) &&
                !(this.configuration.special_options_key in object) &&
                ("id" in object || "to_param" in object || "toParam" in object));
        }
        path_identifier(object) {
            const result = this.unwrap_path_identifier(object);
            return this.is_nullable(result) ||
                (false &&
                    result === false)
                ? ""
                : "" + result;
        }
        unwrap_path_identifier(object) {
            let result = object;
            if (!this.is_object(object)) {
                return object;
            }
            if ("to_param" in object) {
                result = object.to_param;
            }
            else if ("toParam" in object) {
                result = object.toParam;
            }
            else if ("id" in object) {
                result = object.id;
            }
            else {
                result = object;
            }
            return this.is_callable(result) ? result.call(object) : result;
        }
        partition_parameters(parts, required_params, default_options, call_arguments) {
            // eslint-disable-next-line prefer-const
            let { args, options } = this.extract_options(parts.length, call_arguments);
            if (args.length > parts.length) {
                throw new Error("Too many parameters provided for path");
            }
            let use_all_parts = args.length > required_params.length;
            const parts_options = {
                ...this.configuration.default_url_options,
            };
            for (const key in options) {
                const value = options[key];
                if (!hasProp(options, key))
                    continue;
                use_all_parts = true;
                if (parts.includes(key)) {
                    parts_options[key] = value;
                }
            }
            options = {
                ...this.configuration.default_url_options,
                ...default_options,
                ...options,
            };
            const keyword_parameters = {};
            let query_parameters = {};
            for (const key in options) {
                if (!hasProp(options, key))
                    continue;
                const value = options[key];
                if (key === "params") {
                    if (this.is_object(value)) {
                        query_parameters = {
                            ...query_parameters,
                            ...value,
                        };
                    }
                    else {
                        throw new Error("params value should always be an object");
                    }
                }
                else if (this.is_reserved_option(key)) {
                    keyword_parameters[key] = value;
                }
                else {
                    if (!this.is_nullable(value) &&
                        (value !== default_options[key] || required_params.includes(key))) {
                        query_parameters[key] = value;
                    }
                }
            }
            const route_parts = use_all_parts ? parts : required_params;
            let i = 0;
            for (const part of route_parts) {
                if (i < args.length) {
                    const value = args[i];
                    if (!hasProp(parts_options, part)) {
                        query_parameters[part] = value;
                        ++i;
                    }
                }
            }
            return { keyword_parameters, query_parameters };
        }
        build_route(parts, required_params, default_options, route, absolute, args) {
            const { keyword_parameters, query_parameters } = this.partition_parameters(parts, required_params, default_options, args);
            let { trailing_slash, anchor, script_name } = keyword_parameters;
            const missing_params = required_params.filter((param) => !hasProp(query_parameters, param) ||
                this.is_nullable(query_parameters[param]));
            if (missing_params.length) {
                throw new ParametersMissing(...missing_params);
            }
            let result = this.get_prefix() + this.visit(route, query_parameters);
            if (trailing_slash) {
                result = result.replace(/(.*?)[/]?$/, "$1/");
            }
            const url_params = this.serialize(query_parameters);
            if (url_params.length) {
                result += "?" + url_params;
            }
            if (anchor) {
                result += "#" + anchor;
            }
            if (script_name) {
                const last_index = script_name.length - 1;
                if (script_name[last_index] == "/" && result[0] == "/") {
                    script_name = script_name.slice(0, last_index);
                }
                result = script_name + result;
            }
            if (absolute) {
                result = this.route_url(keyword_parameters) + result;
            }
            return result;
        }
        visit(route, parameters, optional = false) {
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return this.visit(route[1], parameters, true);
                case NodeTypes.CAT:
                    return this.visit_cat(route, parameters, optional);
                case NodeTypes.SYMBOL:
                    return this.visit_symbol(route, parameters, optional);
                case NodeTypes.STAR:
                    return this.visit_globbing(route[1], parameters, true);
                case NodeTypes.LITERAL:
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        is_not_nullable(object) {
            return !this.is_nullable(object);
        }
        is_nullable(object) {
            return object === undefined || object === null;
        }
        visit_cat(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, left, right], parameters, optional) {
            const left_part = this.visit(left, parameters, optional);
            let right_part = this.visit(right, parameters, optional);
            if (optional &&
                ((this.is_optional_node(left[0]) && !left_part) ||
                    (this.is_optional_node(right[0]) && !right_part))) {
                return "";
            }
            // if left_part ends on '/' and right_part starts on '/'
            if (left_part[left_part.length - 1] === "/" && right_part[0] === "/") {
                // strip slash from right_part
                // to prevent double slash
                right_part = right_part.substring(1);
            }
            return left_part + right_part;
        }
        visit_symbol(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, key], parameters, optional) {
            const value = this.path_identifier(parameters[key]);
            delete parameters[key];
            if (value.length) {
                return this.encode_segment(value);
            }
            if (optional) {
                return "";
            }
            else {
                throw new ParametersMissing(key);
            }
        }
        encode_segment(segment) {
            if (segment.match(/^[a-zA-Z0-9-]$/)) {
                // Performance optimization for 99% of cases
                return segment;
            }
            return (segment.match(/./gu) || [])
                .map((ch) => {
                const code = ch.charCodeAt(0);
                if (UnescapedRanges.find((range) => code >= range[0] && code <= range[1]) ||
                    UnescapedSpecials.includes(code)) {
                    return ch;
                }
                else {
                    return encodeURIComponent(ch);
                }
            })
                .join("");
        }
        is_optional_node(node) {
            return [NodeTypes.STAR, NodeTypes.SYMBOL, NodeTypes.CAT].includes(node);
        }
        build_path_spec(route, wildcard = false) {
            let key;
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return `(${this.build_path_spec(route[1])})`;
                case NodeTypes.CAT:
                    return (this.build_path_spec(route[1]) + this.build_path_spec(route[2]));
                case NodeTypes.STAR:
                    return this.build_path_spec(route[1], true);
                case NodeTypes.SYMBOL:
                    key = route[1];
                    if (wildcard) {
                        return (key.startsWith("*") ? "" : "*") + key;
                    }
                    else {
                        return ":" + key;
                    }
                    break;
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                case NodeTypes.LITERAL:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        visit_globbing(route, parameters, optional) {
            const key = route[1];
            let value = parameters[key];
            delete parameters[key];
            if (this.is_nullable(value)) {
                return this.visit(route, parameters, optional);
            }
            if (this.is_array(value)) {
                value = value.join("/");
            }
            const result = this.path_identifier(value);
            return encodeURI(result);
        }
        get_prefix() {
            const prefix = this.configuration.prefix;
            return prefix.match("/$")
                ? prefix.substring(0, prefix.length - 1)
                : prefix;
        }
        route(parts_table, route_spec, absolute = false) {
            const required_params = [];
            const parts = [];
            const default_options = {};
            for (const [part, { r: required, d: value }] of Object.entries(parts_table)) {
                parts.push(part);
                if (required) {
                    required_params.push(part);
                }
                if (this.is_not_nullable(value)) {
                    default_options[part] = value;
                }
            }
            const result = (...args) => {
                return this.build_route(parts, required_params, default_options, route_spec, absolute, args);
            };
            result.requiredParams = () => required_params;
            result.toString = () => {
                return this.build_path_spec(route_spec);
            };
            return result;
        }
        route_url(route_defaults) {
            const hostname = route_defaults.host || this.current_host();
            if (!hostname) {
                return "";
            }
            const subdomain = route_defaults.subdomain
                ? route_defaults.subdomain + "."
                : "";
            const protocol = route_defaults.protocol || this.current_protocol();
            let port = route_defaults.port ||
                (!route_defaults.host ? this.current_port() : undefined);
            port = port ? ":" + port : "";
            return protocol + "://" + subdomain + hostname + port;
        }
        current_host() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname)) || "";
        }
        current_protocol() {
            var _a, _b;
            return ((isBrowser && ((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.protocol) === null || _b === void 0 ? void 0 : _b.replace(/:$/, ""))) || "http");
        }
        current_port() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.port)) || "";
        }
        is_object(value) {
            return (typeof value === "object" &&
                Object.prototype.toString.call(value) === "[object Object]");
        }
        is_array(object) {
            return object instanceof Array;
        }
        is_callable(object) {
            return typeof object === "function" && !!object.call;
        }
        is_reserved_option(key) {
            return ReservedOptions.includes(key);
        }
        configure(new_config) {
            if (new_config.prefix) {
                console.warn("JsRoutes configuration prefix option is deprecated in favor of default_url_options.script_name.");
            }
            this.configuration = { ...this.configuration, ...new_config };
            return this.configuration;
        }
        config() {
            return { ...this.configuration };
        }
        is_module_supported(name) {
            return ModuleReferences[name].isSupported();
        }
        ensure_module_supported(name) {
            if (!this.is_module_supported(name)) {
                throw new Error(`${name} is not supported by runtime`);
            }
        }
        define_module(name, module) {
            this.ensure_module_supported(name);
            ModuleReferences[name].define(module);
            return module;
        }
    }
    const utils = new UtilsClass();
    // We want this helper name to be short
    const __jsr = {
        r(parts_table, route_spec, absolute) {
            return utils.route(parts_table, route_spec, absolute);
        },
    };
    return utils.define_module("ESM", {
        ...__jsr,
        configure: (config) => {
            return utils.configure(config);
        },
        config: () => {
            return utils.config();
        },
        serialize: (object) => {
            return utils.serialize(object);
        },
        ...{},
    });
})();
export const configure = __jsr.configure;

export const config = __jsr.config;

export const serialize = __jsr.serialize;

/**
 * Generates rails route to
 * /accepted_offers
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accepted_offers_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"accepted_offers"]]);

/**
 * Generates rails route to
 * /admin_dashboards(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_dashboards_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin_dashboards"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /api/feedbacks
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_feedbacks_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[6,"feedbacks"]]]]);

/**
 * Generates rails route to
 * /api/friends_searches
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_friends_searches_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[6,"friends_searches"]]]]);

/**
 * Generates rails route to
 * /api/inline_files
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_inline_files_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[6,"inline_files"]]]]);

/**
 * Generates rails route to
 * /api/preview
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_preview_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[6,"preview"]]]]);

/**
 * Generates rails route to
 * /api/recipients
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_recipients_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[6,"recipients"]]]]);

/**
 * Generates rails route to
 * /api/rooms
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_rooms_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[6,"rooms"]]]]);

/**
 * Generates rails route to
 * /api/timeline
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_timeline_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[6,"timeline"]]]]);

/**
 * Generates rails route to
 * /api/tour_status
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_tour_status_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[6,"tour_status"]]]]);

/**
 * Generates rails route to
 * /auth/failure
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auth_failure_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[6,"failure"]]]]);

/**
 * Generates rails route to
 * /boards/:id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const board_path = /*#__PURE__*/ __jsr.r({"id":{"r":true}}, [2,[7,"/"],[2,[6,"boards"],[2,[7,"/"],[3,"id"]]]]);

/**
 * Generates rails route to
 * /boards/:board_id/comments/:id
 * @param {any} board_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const board_comment_path = /*#__PURE__*/ __jsr.r({"board_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"boards"],[2,[7,"/"],[2,[3,"board_id"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[3,"id"]]]]]]]]);

/**
 * Generates rails route to
 * /boards/:board_id/comments
 * @param {any} board_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const board_comments_path = /*#__PURE__*/ __jsr.r({"board_id":{"r":true}}, [2,[7,"/"],[2,[6,"boards"],[2,[7,"/"],[2,[3,"board_id"],[2,[7,"/"],[6,"comments"]]]]]]);

/**
 * Generates rails route to
 * /boards/:board_id/results
 * @param {any} board_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const board_results_path = /*#__PURE__*/ __jsr.r({"board_id":{"r":true}}, [2,[7,"/"],[2,[6,"boards"],[2,[7,"/"],[2,[3,"board_id"],[2,[7,"/"],[6,"results"]]]]]]);

/**
 * Generates rails route to
 * /boards
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const boards_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"boards"]]);

/**
 * Generates rails route to
 * /boards/closed
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const closed_boards_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[2,[6,"boards"],[2,[7,"/"],[6,"closed"]]]]);

/**
 * Generates rails route to
 * /consent
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const consent_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"consent"]]);

/**
 * Generates rails route to
 * /daily_reports/:id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const daily_report_path = /*#__PURE__*/ __jsr.r({"id":{"r":true}}, [2,[7,"/"],[2,[6,"daily_reports"],[2,[7,"/"],[3,"id"]]]]);

/**
 * Generates rails route to
 * /daily_report_drafts/:id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const daily_report_draft_path = /*#__PURE__*/ __jsr.r({"id":{"r":true}}, [2,[7,"/"],[2,[6,"daily_report_drafts"],[2,[7,"/"],[3,"id"]]]]);

/**
 * Generates rails route to
 * /daily_report_drafts
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const daily_report_drafts_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"daily_report_drafts"]]);

/**
 * Generates rails route to
 * /daily_report_searches
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const daily_report_searches_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"daily_report_searches"]]);

/**
 * Generates rails route to
 * /daily_reports
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const daily_reports_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"daily_reports"]]);

/**
 * Generates rails route to
 * /boards/:id/edit
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_board_path = /*#__PURE__*/ __jsr.r({"id":{"r":true}}, [2,[7,"/"],[2,[6,"boards"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"edit"]]]]]]);

/**
 * Generates rails route to
 * /daily_reports/:id/edit
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_daily_report_path = /*#__PURE__*/ __jsr.r({"id":{"r":true}}, [2,[7,"/"],[2,[6,"daily_reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"edit"]]]]]]);

/**
 * Generates rails route to
 * /daily_report_drafts/:id/edit
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_daily_report_draft_path = /*#__PURE__*/ __jsr.r({"id":{"r":true}}, [2,[7,"/"],[2,[6,"daily_report_drafts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"edit"]]]]]]);

/**
 * Generates rails route to
 * /settings/careers/:id/edit
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_settings_career_path = /*#__PURE__*/ __jsr.r({"id":{"r":true}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"careers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"edit"]]]]]]]]);

/**
 * Generates rails route to
 * /settings/notification/edit
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_settings_notification_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"notification"],[2,[7,"/"],[6,"edit"]]]]]]);

/**
 * Generates rails route to
 * /settings/portfolio/edit
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_settings_portfolio_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"portfolio"],[2,[7,"/"],[6,"edit"]]]]]]);

/**
 * Generates rails route to
 * /settings/profile/edit
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_settings_profile_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[6,"edit"]]]]]]);

/**
 * Generates rails route to
 * /@:screen_name/boards/:id/edit
 * @param {any} screen_name
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_user_board_path = /*#__PURE__*/ __jsr.r({"screen_name":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"@"],[2,[3,"screen_name"],[2,[7,"/"],[2,[6,"boards"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"edit"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/rooms/:id/fragment
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const fragment_api_room_path = /*#__PURE__*/ __jsr.r({"id":{"r":true}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"rooms"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"fragment"]]]]]]]]);

/**
 * Generates rails route to
 * /invitation_link
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const invitation_link_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"invitation_link"]]);

/**
 * Generates rails route to
 * /invitations
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const invitations_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"invitations"]]);

/**
 * Generates rails route to
 * /logout
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const logout_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"logout"]]);

/**
 * Generates rails route to
 * /maybe_friends
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const maybe_friends_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"maybe_friends"]]);

/**
 * Generates rails route to
 * /messages/conversations/:id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const messages_conversation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true}}, [2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[6,"conversations"],[2,[7,"/"],[3,"id"]]]]]]);

/**
 * Generates rails route to
 * /messages/conversation_streams/:id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const messages_conversation_stream_path = /*#__PURE__*/ __jsr.r({"id":{"r":true}}, [2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[6,"conversation_streams"],[2,[7,"/"],[3,"id"]]]]]]);

/**
 * Generates rails route to
 * /messages/conversations
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const messages_conversations_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[6,"conversations"]]]]);

/**
 * Generates rails route to
 * /messages/rooms/:id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const messages_room_path = /*#__PURE__*/ __jsr.r({"id":{"r":true}}, [2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[6,"rooms"],[2,[7,"/"],[3,"id"]]]]]]);

/**
 * Generates rails route to
 * /messages/rooms
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const messages_rooms_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[6,"rooms"]]]]);

/**
 * Generates rails route to
 * /jobs
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"jobs"]]);

/**
 * Generates rails route to
 * /jobs/applications/:application_id/jobs/bulk_discards(.:format)
 * @param {any} application_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_application_bulk_discards_path = /*#__PURE__*/ __jsr.r({"application_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[6,"bulk_discards"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /jobs/applications/:application_id/jobs/bulk_retries(.:format)
 * @param {any} application_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_application_bulk_retries_path = /*#__PURE__*/ __jsr.r({"application_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[6,"bulk_retries"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /jobs/applications/:application_id/jobs/:id(.:format)
 * @param {any} application_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_application_job_path = /*#__PURE__*/ __jsr.r({"application_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /jobs/applications/:application_id/jobs/:job_id/discard(.:format)
 * @param {any} application_id
 * @param {any} job_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_application_job_discard_path = /*#__PURE__*/ __jsr.r({"application_id":{"r":true},"job_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"job_id"],[2,[7,"/"],[2,[6,"discard"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /jobs/applications/:application_id/jobs/:job_id/dispatch(.:format)
 * @param {any} application_id
 * @param {any} job_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_application_job_dispatch_path = /*#__PURE__*/ __jsr.r({"application_id":{"r":true},"job_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"job_id"],[2,[7,"/"],[2,[6,"dispatch"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /jobs/applications/:application_id/jobs/:job_id/retry(.:format)
 * @param {any} application_id
 * @param {any} job_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_application_job_retry_path = /*#__PURE__*/ __jsr.r({"application_id":{"r":true},"job_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"job_id"],[2,[7,"/"],[2,[6,"retry"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /jobs/applications/:application_id/:status/jobs(.:format)
 * @param {any} application_id
 * @param {any} status
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_application_jobs_path = /*#__PURE__*/ __jsr.r({"application_id":{"r":true},"status":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[3,"status"],[2,[7,"/"],[2,[6,"jobs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /jobs/applications/:application_id/queues/:id(.:format)
 * @param {any} application_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_application_queue_path = /*#__PURE__*/ __jsr.r({"application_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"queues"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /jobs/applications/:application_id/queues/:queue_id/pause(.:format)
 * @param {any} application_id
 * @param {any} queue_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_application_queue_pause_path = /*#__PURE__*/ __jsr.r({"application_id":{"r":true},"queue_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"queues"],[2,[7,"/"],[2,[3,"queue_id"],[2,[7,"/"],[2,[6,"pause"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /jobs/applications/:application_id/queues(.:format)
 * @param {any} application_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_application_queues_path = /*#__PURE__*/ __jsr.r({"application_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"queues"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /jobs/applications/:application_id/recurring_tasks/:id(.:format)
 * @param {any} application_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_application_recurring_task_path = /*#__PURE__*/ __jsr.r({"application_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"recurring_tasks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /jobs/applications/:application_id/recurring_tasks(.:format)
 * @param {any} application_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_application_recurring_tasks_path = /*#__PURE__*/ __jsr.r({"application_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"recurring_tasks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /jobs/applications/:application_id/workers/:id(.:format)
 * @param {any} application_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_application_worker_path = /*#__PURE__*/ __jsr.r({"application_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"workers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /jobs/applications/:application_id/workers(.:format)
 * @param {any} application_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_application_workers_path = /*#__PURE__*/ __jsr.r({"application_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"workers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /jobs/jobs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_job_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /jobs/:status/jobs(.:format)
 * @param {any} status
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_jobs_path = /*#__PURE__*/ __jsr.r({"status":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[3,"status"],[2,[7,"/"],[2,[6,"jobs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /jobs/queues/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_queue_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"queues"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /jobs/queues(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_queues_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"jobs"]],[7,"/"]],[2,[6,"queues"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /jobs/
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mission_control_jobs_root_path = /*#__PURE__*/ __jsr.r({}, [2,[2,[7,"/"],[6,"jobs"]],[7,"/"]]);

/**
 * Generates rails route to
 * /api/rooms/:id/mute
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mute_api_room_path = /*#__PURE__*/ __jsr.r({"id":{"r":true}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"rooms"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"mute"]]]]]]]]);

/**
 * Generates rails route to
 * /boards/my
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const my_boards_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[2,[6,"boards"],[2,[7,"/"],[6,"my"]]]]);

/**
 * Generates rails route to
 * /boards/new
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_board_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[2,[6,"boards"],[2,[7,"/"],[6,"new"]]]]);

/**
 * Generates rails route to
 * /boards/:board_id/results/new
 * @param {any} board_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_board_result_path = /*#__PURE__*/ __jsr.r({"board_id":{"r":true}}, [2,[7,"/"],[2,[6,"boards"],[2,[7,"/"],[2,[3,"board_id"],[2,[7,"/"],[2,[6,"results"],[2,[7,"/"],[6,"new"]]]]]]]]);

/**
 * Generates rails route to
 * /daily_report_drafts/new
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_daily_report_draft_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[2,[6,"daily_report_drafts"],[2,[7,"/"],[6,"new"]]]]);

/**
 * Generates rails route to
 * /invitations/new
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_invitation_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[2,[6,"invitations"],[2,[7,"/"],[6,"new"]]]]);

/**
 * Generates rails route to
 * /registration/new
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_registration_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[2,[6,"registration"],[2,[7,"/"],[6,"new"]]]]);

/**
 * Generates rails route to
 * /reports/new
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_report_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[6,"new"]]]]);

/**
 * Generates rails route to
 * /settings/careers/new
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_settings_career_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"careers"],[2,[7,"/"],[6,"new"]]]]]]);

/**
 * Generates rails route to
 * /@:screen_name/boards/new
 * @param {any} screen_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_board_path = /*#__PURE__*/ __jsr.r({"screen_name":{"r":true}}, [2,[7,"/"],[2,[6,"@"],[2,[3,"screen_name"],[2,[7,"/"],[2,[6,"boards"],[2,[7,"/"],[6,"new"]]]]]]]);

/**
 * Generates rails route to
 * /@:screen_name/conditions/new
 * @param {any} screen_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_condition_path = /*#__PURE__*/ __jsr.r({"screen_name":{"r":true}}, [2,[7,"/"],[2,[6,"@"],[2,[3,"screen_name"],[2,[7,"/"],[2,[6,"conditions"],[2,[7,"/"],[6,"new"]]]]]]]);

/**
 * Generates rails route to
 * /initial/new
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_initial_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[2,[6,"initial"],[2,[7,"/"],[6,"new"]]]]);

/**
 * Generates rails route to
 * /withdrawal/new
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_withdrawal_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[2,[6,"withdrawal"],[2,[7,"/"],[6,"new"]]]]);

/**
 * Generates rails route to
 * /notifications
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const notifications_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"notifications"]]);

/**
 * Generates rails route to
 * /notifications/reading
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const notifications_reading_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[6,"reading"]]]]);

/**
 * Generates rails route to
 * /offers
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const offers_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"offers"]]);

/**
 * Generates rails route to
 * /healthchecks
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const okcomputer_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"healthchecks"]]);

/**
 * Generates rails route to
 * /healthchecks/:check(.:format)
 * @param {any} check
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const okcomputer_okcomputer_check_path = /*#__PURE__*/ __jsr.r({"check":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"healthchecks"]],[7,"/"]],[2,[3,"check"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /healthchecks/all(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const okcomputer_okcomputer_checks_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"healthchecks"]],[7,"/"]],[2,[6,"all"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /healthchecks/
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const okcomputer_root_path = /*#__PURE__*/ __jsr.r({}, [2,[2,[7,"/"],[6,"healthchecks"]],[7,"/"]]);

/**
 * Generates rails route to
 * /*id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const page_path = /*#__PURE__*/ __jsr.r({"id":{"r":true}}, [2,[7,"/"],[5,[3,"id"]]]);

/**
 * Generates rails route to
 * /pending_offers
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pending_offers_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"pending_offers"]]);

/**
 * Generates rails route to
 * /up(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_health_check_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"up"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /@:screen_name/conditions/renew
 * @param {any} screen_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const renew_user_conditions_path = /*#__PURE__*/ __jsr.r({"screen_name":{"r":true}}, [2,[7,"/"],[2,[6,"@"],[2,[3,"screen_name"],[2,[7,"/"],[2,[6,"conditions"],[2,[7,"/"],[6,"renew"]]]]]]]);

/**
 * Generates rails route to
 * /reports
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reports_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"reports"]]);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const root_path = /*#__PURE__*/ __jsr.r({}, [7,"/"]);

/**
 * Generates rails route to
 * /api/content_visible_friends/search
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_api_content_visible_friends_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"content_visible_friends"],[2,[7,"/"],[6,"search"]]]]]]);

/**
 * Generates rails route to
 * /users/search
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_users_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[6,"search"]]]]);

/**
 * Generates rails route to
 * /settings
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"settings"]]);

/**
 * Generates rails route to
 * /settings/careers/:id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_career_path = /*#__PURE__*/ __jsr.r({"id":{"r":true}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"careers"],[2,[7,"/"],[3,"id"]]]]]]);

/**
 * Generates rails route to
 * /settings/careers
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_careers_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[6,"careers"]]]]);

/**
 * Generates rails route to
 * /settings/notification
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_notification_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[6,"notification"]]]]);

/**
 * Generates rails route to
 * /settings/portfolio
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_portfolio_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[6,"portfolio"]]]]);

/**
 * Generates rails route to
 * /settings/profile
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_profile_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[6,"profile"]]]]);

/**
 * Generates rails route to
 * /settings/social
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_social_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[6,"social"]]]]);

/**
 * Generates rails route to
 * /recede_historical_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const turbo_recede_historical_location_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"recede_historical_location"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /refresh_historical_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const turbo_refresh_historical_location_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"refresh_historical_location"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /resume_historical_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const turbo_resume_historical_location_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"resume_historical_location"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /api/rooms/:id/unmute
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unmute_api_room_path = /*#__PURE__*/ __jsr.r({"id":{"r":true}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"rooms"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[6,"unmute"]]]]]]]]);

/**
 * Generates rails route to
 * /unsuggested_friendships
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unsuggested_friendships_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"unsuggested_friendships"]]);

/**
 * Generates rails route to
 * /@:screen_name
 * @param {any} screen_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_path = /*#__PURE__*/ __jsr.r({"screen_name":{"r":true}}, [2,[7,"/"],[2,[6,"@"],[3,"screen_name"]]]);

/**
 * Generates rails route to
 * /user_announcement(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_announcement_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"user_announcement"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /@:screen_name/boards/:id
 * @param {any} screen_name
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_board_path = /*#__PURE__*/ __jsr.r({"screen_name":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"@"],[2,[3,"screen_name"],[2,[7,"/"],[2,[6,"boards"],[2,[7,"/"],[3,"id"]]]]]]]);

/**
 * Generates rails route to
 * /@:screen_name/boards/:board_id/meat
 * @param {any} screen_name
 * @param {any} board_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_board_meat_path = /*#__PURE__*/ __jsr.r({"screen_name":{"r":true},"board_id":{"r":true}}, [2,[7,"/"],[2,[6,"@"],[2,[3,"screen_name"],[2,[7,"/"],[2,[6,"boards"],[2,[7,"/"],[2,[3,"board_id"],[2,[7,"/"],[6,"meat"]]]]]]]]]);

/**
 * Generates rails route to
 * /@:screen_name/boards
 * @param {any} screen_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_boards_path = /*#__PURE__*/ __jsr.r({"screen_name":{"r":true}}, [2,[7,"/"],[2,[6,"@"],[2,[3,"screen_name"],[2,[7,"/"],[6,"boards"]]]]]);

/**
 * Generates rails route to
 * /@:screen_name/conditions/:condition_id/meat
 * @param {any} screen_name
 * @param {any} condition_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_condition_meat_path = /*#__PURE__*/ __jsr.r({"screen_name":{"r":true},"condition_id":{"r":true}}, [2,[7,"/"],[2,[6,"@"],[2,[3,"screen_name"],[2,[7,"/"],[2,[6,"conditions"],[2,[7,"/"],[2,[3,"condition_id"],[2,[7,"/"],[6,"meat"]]]]]]]]]);

/**
 * Generates rails route to
 * /@:screen_name/conditions/:condition_id/meatgazer
 * @param {any} screen_name
 * @param {any} condition_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_condition_meatgazer_index_path = /*#__PURE__*/ __jsr.r({"screen_name":{"r":true},"condition_id":{"r":true}}, [2,[7,"/"],[2,[6,"@"],[2,[3,"screen_name"],[2,[7,"/"],[2,[6,"conditions"],[2,[7,"/"],[2,[3,"condition_id"],[2,[7,"/"],[6,"meatgazer"]]]]]]]]]);

/**
 * Generates rails route to
 * /@:screen_name/conditions
 * @param {any} screen_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_conditions_path = /*#__PURE__*/ __jsr.r({"screen_name":{"r":true}}, [2,[7,"/"],[2,[6,"@"],[2,[3,"screen_name"],[2,[7,"/"],[6,"conditions"]]]]]);

/**
 * Generates rails route to
 * /@:screen_name/daily_reports/:id
 * @param {any} screen_name
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_daily_report_path = /*#__PURE__*/ __jsr.r({"screen_name":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"@"],[2,[3,"screen_name"],[2,[7,"/"],[2,[6,"daily_reports"],[2,[7,"/"],[3,"id"]]]]]]]);

/**
 * Generates rails route to
 * /@:screen_name/daily_reports/:daily_report_id/comments/:id
 * @param {any} screen_name
 * @param {any} daily_report_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_daily_report_comment_path = /*#__PURE__*/ __jsr.r({"screen_name":{"r":true},"daily_report_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"@"],[2,[3,"screen_name"],[2,[7,"/"],[2,[6,"daily_reports"],[2,[7,"/"],[2,[3,"daily_report_id"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[3,"id"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /@:screen_name/daily_reports/:daily_report_id/comments/:comment_id/meat
 * @param {any} screen_name
 * @param {any} daily_report_id
 * @param {any} comment_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_daily_report_comment_meat_path = /*#__PURE__*/ __jsr.r({"screen_name":{"r":true},"daily_report_id":{"r":true},"comment_id":{"r":true}}, [2,[7,"/"],[2,[6,"@"],[2,[3,"screen_name"],[2,[7,"/"],[2,[6,"daily_reports"],[2,[7,"/"],[2,[3,"daily_report_id"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"comment_id"],[2,[7,"/"],[6,"meat"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /@:screen_name/daily_reports/:daily_report_id/comments/:comment_id/meatgazer
 * @param {any} screen_name
 * @param {any} daily_report_id
 * @param {any} comment_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_daily_report_comment_meatgazer_index_path = /*#__PURE__*/ __jsr.r({"screen_name":{"r":true},"daily_report_id":{"r":true},"comment_id":{"r":true}}, [2,[7,"/"],[2,[6,"@"],[2,[3,"screen_name"],[2,[7,"/"],[2,[6,"daily_reports"],[2,[7,"/"],[2,[3,"daily_report_id"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"comment_id"],[2,[7,"/"],[6,"meatgazer"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /@:screen_name/daily_reports/:daily_report_id/comments
 * @param {any} screen_name
 * @param {any} daily_report_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_daily_report_comments_path = /*#__PURE__*/ __jsr.r({"screen_name":{"r":true},"daily_report_id":{"r":true}}, [2,[7,"/"],[2,[6,"@"],[2,[3,"screen_name"],[2,[7,"/"],[2,[6,"daily_reports"],[2,[7,"/"],[2,[3,"daily_report_id"],[2,[7,"/"],[6,"comments"]]]]]]]]]);

/**
 * Generates rails route to
 * /@:screen_name/daily_reports/:daily_report_id/meat
 * @param {any} screen_name
 * @param {any} daily_report_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_daily_report_meat_path = /*#__PURE__*/ __jsr.r({"screen_name":{"r":true},"daily_report_id":{"r":true}}, [2,[7,"/"],[2,[6,"@"],[2,[3,"screen_name"],[2,[7,"/"],[2,[6,"daily_reports"],[2,[7,"/"],[2,[3,"daily_report_id"],[2,[7,"/"],[6,"meat"]]]]]]]]]);

/**
 * Generates rails route to
 * /@:screen_name/daily_reports/:daily_report_id/meatgazer
 * @param {any} screen_name
 * @param {any} daily_report_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_daily_report_meatgazer_index_path = /*#__PURE__*/ __jsr.r({"screen_name":{"r":true},"daily_report_id":{"r":true}}, [2,[7,"/"],[2,[6,"@"],[2,[3,"screen_name"],[2,[7,"/"],[2,[6,"daily_reports"],[2,[7,"/"],[2,[3,"daily_report_id"],[2,[7,"/"],[6,"meatgazer"]]]]]]]]]);

/**
 * Generates rails route to
 * /@:screen_name/daily_reports
 * @param {any} screen_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_daily_reports_path = /*#__PURE__*/ __jsr.r({"screen_name":{"r":true}}, [2,[7,"/"],[2,[6,"@"],[2,[3,"screen_name"],[2,[7,"/"],[6,"daily_reports"]]]]]);

/**
 * Generates rails route to
 * /@:screen_name/friendship
 * @param {any} screen_name
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_friendship_path = /*#__PURE__*/ __jsr.r({"screen_name":{"r":true}}, [2,[7,"/"],[2,[6,"@"],[2,[3,"screen_name"],[2,[7,"/"],[6,"friendship"]]]]]);

/**
 * Generates rails route to
 * /initial
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_initial_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"initial"]]);

/**
 * Generates rails route to
 * /violation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const violation_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"violation"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /welcome
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const welcome_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"welcome"]]);

/**
 * Generates rails route to
 * /withdrawal
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const withdrawal_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"withdrawal"]]);


